import { Button, Group } from '@mantine/core'
import { MonthPickerInput } from '@mantine/dates'
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react'
import { useCallback } from 'react'

interface Props {
  period: Date
  onChange: (period: Date) => void
}

export function PeriodPicker(props: Props) {
  let prev = useCallback(() => {
    const m = new Date(props.period)
    m.setMonth(m.getMonth() - 1)
    props.onChange(m)
  }, [props])

  let next = useCallback(() => {
    const m = new Date(props.period)
    m.setMonth(m.getMonth() + 1)
    props.onChange(m)
  }, [props])

  return (
    <Group gap="xs">
      <MonthPickerInput
        value={props.period}
        onChange={(v) => props.onChange(v || new Date())}
        w="230"
        size="lg"
      />
      <Button
        onClick={prev}
        variant="light"
        color="black"
        style={{ padding: '0 10px' }}
        size="lg"
      >
        <IconArrowLeft />
      </Button>
      <Button
        onClick={next}
        variant="light"
        color="black"
        style={{ padding: '0 10px' }}
        size="lg"
      >
        <IconArrowRight />
      </Button>
    </Group>
  )
}
